// extracted by mini-css-extract-plugin
module.exports = {"Layout":"_2wiTFf8TGSrYRD5Qxk01JQ"};